import { api, ApiError } from "../api";
import { h } from "../dom";
import type { User } from "../types";

export function renderLogin(root: HTMLElement, onLogin: (user: User) => void): void {
  const error = h("div", { className: "form-error" });
  const username = h("input", { name: "username", autocomplete: "username", required: true, autofocus: true });
  const password = h("input", { name: "password", type: "password", autocomplete: "current-password", required: true });

  const form = h(
    "form",
    {
      className: "login-card",
      onSubmit: async (e: Event) => {
        e.preventDefault();
        error.textContent = "";
        try {
          const user = await api<User>("/api/auth/login", {
            method: "POST",
            body: { username: username.value, password: password.value },
          });
          onLogin(user);
        } catch (err) {
          error.textContent = err instanceof ApiError ? err.message : "Login failed";
        }
      },
    },
    h("h1", {}, "Tree&Terrain Labeling"),
    h("label", {}, "Username", username),
    h("label", {}, "Password", password),
    error,
    h("button", { className: "btn btn-primary", type: "submit" }, "Log in"),
  );
  root.append(h("div", { className: "login-wrap" }, form));
}
